import { Color } from "@starrez/starryui";
import styled from "styled-components";

const speed = 0.2;

export const ImageContainerDiv = styled.div`
    background-color: ${Color.Grey.G40};
    height: 200px;
    overflow: hidden;
    position: relative;
    vertical-align: middle;

    &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,255,255, 0);
        transition: all ${speed}s linear;
    }

    > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        object-position: top;

    }
`;

export const CaptionDiv = styled.div`
    /* stylelint-disable value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    border-top: 1px solid ${Color.Grey.G30};
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 18px 24px 0;
    text-align: center;
    transition: all ${speed}s;
    width: 100%;
    word-break: break-word;
`;

export const ImageTileContainerDiv = styled.div<{ Selected: boolean | undefined }>`
    border: ${(props) => props.Selected
        ? `2px solid ${Color.Blue.B60}`
        : `1px solid ${Color.Grey.G30}`};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    height: 275px;
    overflow: hidden;
    transition: all ${speed}s;
    width: 210px;

    &:hover {
        background-color: ${Color.Blue.B20};
        border: ${(props) => props.Selected
        ? `2px solid ${Color.Blue.B60}`
        : `1px solid ${Color.Blue.B60}`};
        cursor: pointer;

        ${ImageContainerDiv}:before {
            background: rgba(18,55,78, 0.5);
        }

        ${CaptionDiv} {
            color: ${Color.Blue.B60};
        };
    };
`;
